import styled from 'styled-components'
import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'
import { CommonLinkButton } from 'components/Button'
import { Icon } from '@mdi/react'

export const UploadTemplateDesktopButton = styled(CommonButton)`
  display: none;
  text-transform: capitalize;
  background: transparent;
  font-weight: 900;
  height: 40px;
  padding: 12px 14px;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const UploadTemplateMobileButton = styled(CommonLinkButton)`
  display: flex;
  :hover {
    opacity: 0.8;
  }
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const TemplateIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`
